module.exports = __webpack_public_path__ + "static/img/son19_active.8c310584.png";